// extracted by mini-css-extract-plugin
module.exports = {"root":"modelSpecs_root__4QvQr","table":"modelSpecs_table__BiY8K","versionTh":"modelSpecs_versionTh__JKUa8"};